export default __webpack_public_path__ + "static/media/ReportIcon-Arthroscope-MS.118157da.jpg";